import {useContext} from 'react'
import { Link } from 'react-router-dom'
import Translate from '../Translate/Translate'
import './Breadcrams.css'
import { LanguageContext } from '../../context';

const Breadcrams = ({pagename}) => {
    const { language } = useContext(LanguageContext);
  return (
    <div className='breadcrams-container'>
        <Link to={`/${language}`}><Translate>HomePage</Translate></Link>
        <p>{pagename}</p>
    </div>
  )
}

export default Breadcrams